(() => {
  if (window.sentryLandingVideoInitialized) return;
  window.sentryLandingVideoInitialized = true;

  function setup(root) {
    const video = root.querySelector('video');
    const overlay = root.querySelector('[data-sentry-video-overlay]');
    const status = root.querySelector('[data-sentry-video-status]');
    if (!video || !overlay || !status || video.dataset.sentryReady) return;
    video.dataset.sentryReady = 'true';
    const sync = () => { overlay.hidden = !video.paused && !video.ended; };
    const error = () => {
      overlay.hidden = false;
      status.textContent = 'The video could not play. Please try again using the video controls.';
      status.hidden = false;
    };
    video.addEventListener('play', () => { sync(); status.hidden = true; });
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);
    video.addEventListener('error', error);
    root.querySelectorAll('[data-sentry-play]').forEach(control => {
      control.addEventListener('click', event => {
        event.preventDefault();
        status.hidden = true;
        video.muted = false;
        if (video.ended) video.currentTime = 0;
        // Call play directly in the click handler so mobile browsers allow it.
        video.play().catch(error);
        if (control !== overlay) {
          video.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'center',
          });
          video.focus({ preventScroll: true });
        }
      });
    });
    sync();
  }

  function initialize() {
    document.querySelectorAll('[data-sentry-story]').forEach(setup);
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();